import { FC } from 'react';
import classNames from 'classnames';

interface IColorCardsProps {
  colors: string[];
  selected?: string | null;
  onSelect?: (color: string) => void;
}

export const ColorCards: FC<IColorCardsProps> = ({ colors, selected, onSelect }) => {
  return (
    <div className="grid grid-cols-4 gap-3 mt-6">
      {colors.map((color, idx) => (
        <button
          key={idx}
          onClick={() => onSelect?.(color)}
          className={classNames(
            'w-[54.5px] h-[71px] rounded-[12px] transition-all',
            selected === color ? 'border-white scale-105' : 'border-transparent',
          )}
          style={{ backgroundColor: color }}
        />
      ))}
    </div>
  );
};
